import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component

/**
 * Represents the ReportsCustomerView class.
 * @extends JetView
 */
export default class ReportsCustomerView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Unique identifier for the layout
                    type: 'wide', // Layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Unique identifier for the tab bar
                            height: 43, // Height of the tab bar
                            tabMinWidth: 190, // Minimum width of each tab
                            tabMoreWidth: 80, // Width of the 'more' tab
                            moreTemplate: function () {
                                // Template for the 'more' tab
                                return (
                                    "<div style='font-weight: bold;border-left: 1px solid #ebedf0;height: 30px;line-height: 2;padding-left: 5px;color: #263043;'>" +
                                    _('Ver más') + // Translated text for 'more'
                                    '</div>'
                                );
                            },
                            options: [
                                {
                                    id: 'customers.casinoGamesReport', // Unique identifier for the report option
                                    value: _('Reporte de Casino'), // Translated text for the report option
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
